import React from "react";

export default function Ipad({ className, onClick, style }) {
  return (
    <svg
      width="30"
      height="23"
      viewBox="0 0 30 23"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.03267 2.0765H26.1885C27.1477 2.0765 27.9252 2.85404 27.9252 3.81319V19.7329C27.9252 20.692 27.1477 21.4695 26.1885 21.4695H3.03267C2.07352 21.4695 1.29598 20.692 1.29598 19.7329V3.81319C1.29598 2.85404 2.07352 2.0765 3.03267 2.0765ZM0.138184 3.81319C0.138184 2.21461 1.43409 0.918701 3.03267 0.918701H26.1885C27.7871 0.918701 29.083 2.21461 29.083 3.81319V19.7329C29.083 21.3314 27.7871 22.6273 26.1885 22.6273H3.03267C1.43409 22.6273 0.138184 21.3314 0.138184 19.7329V3.81319ZM12.5844 19.7329C12.4246 19.7329 12.295 19.8625 12.295 20.0223C12.295 20.1822 12.4246 20.3118 12.5844 20.3118H16.6367C16.7966 20.3118 16.9262 20.1822 16.9262 20.0223C16.9262 19.8625 16.7966 19.7329 16.6367 19.7329H12.5844Z"
        fill="inherit"
      />
    </svg>
  );
}
